/**
 * Destination UI Components
 */

export {DestinationCard} from "./card";
export type {DestinationCardProps} from "./card";
